import React from 'react';
type TrustRowProps = {
  className?: string;
  accessLabel?: string;
  tone?: 'light' | 'dark';
};
export function TrustRow({
  className = '',
  accessLabel = 'Instant Access',
  tone = 'light'
}: TrustRowProps) {
  const items = ['Secure Payment', accessLabel, '7-Day Guarantee'];
  return <ul className={`flex flex-wrap items-center justify-center gap-x-2 gap-y-0.5 text-[10px] font-semibold uppercase tracking-wide sm:text-[11px] ${tone === 'dark' ? 'text-white/70' : 'text-muted'} ${className}`} data-id="element-247" data-mp="2cpo0dlb7rpao">
      {items.map((item, index) => <li key={item} className="flex items-center gap-2" data-id="element-248" data-mp="1k2a29jvs4noz" data-mpi={index}>
          {index > 0 && <span aria-hidden="true" data-id="element-249" data-mp="1yy9hrfl7xq45">·</span>}
          {item}
        </li>)}
    </ul>;
}